import React from 'react';
export const InfiniteScrollHandler = ({ triggerDistance = 200, onReachEnd, children, className, height }) => {
    const handleScroll = (event) => {
        const { target } = event;
        const { scrollTop, clientHeight, scrollHeight } = target;
        const isAlmostReachBottom = scrollHeight - scrollTop - clientHeight <= triggerDistance;
        if (isAlmostReachBottom && typeof onReachEnd === 'function') {
            onReachEnd();
        }
    };
    return <div onScroll={handleScroll} className={className} style={height ? { height } : {}}>
    {children}
  </div>;
};
